var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2426.5px",
    height: "1530.8px",
    viewBox: "0 0 2426.5 1530.8",
    style: {
      enableBackground: "new 0 0 2426.5 1530.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#315881;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#DFA43B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.6,0h2109.2c87.6,0,158.6,71,158.6,158.6v1213.5c0,87.6-71,158.6-158.6,158.6H158.6 C71,1530.8,0,1459.7,0,1372.1V158.6C0,71,71,0,158.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2426.5,174.4C2426.5,57.8,2365.9,0,2248.4,0H178C119.3,0,76.2,15.6,47.7,47.7C15.6,79.8,0,121.1,0,174.4v1182 c0,53.2,15.6,93.6,47.7,126.6c33,32.1,75.3,47.7,130.3,47.7h2070.4c117.5,0,178.1-58.7,178.1-174.4V174.4z M2248.4,27.5 c97.3,0,146.8,49.6,146.8,146.8v1182c0,98.2-49.6,146.8-146.8,146.8H178c-46.8,0-82.6-13.8-109.2-41.3 c-27.5-26.6-41.3-63.3-41.3-105.5v-1182C27.5,77.1,76.2,27.5,178,27.5H2248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.6,95.4c-39.5,0-64.2,6.4-78,20.2c-11.9,15.6-17.4,41.3-17.4,78.9v256h2228.2v-256 c0-67-33.1-99.1-99.1-99.1H194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.1,1332.5c0,67.9,32.1,102.8,95.4,102.8h2033.7c66.1,0,99.1-34.9,99.1-102.8v-256H99.1V1332.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M837,559.8c0,11.9-1.8,21.1-6.4,27.5L670,867.3l-10.1-341.4h-257l86.3,41.3c24.8,15.6,37.6,35.8,37.6,61.5 l23.9,362.5h125.7l301-465.3H823.2C832.4,534.1,837,547,837,559.8z M1875.9,539.6l10.1-13.8H1729c5.5,5.5,7.3,8.3,7.3,10.1 c-1.9,7.3-5.5,11.9-7.3,17.4L1500.5,970c-5.5,7.3-11,13.8-17.4,21.1h129.4l-6.4-13.8c0-11.9,6.4-33.9,20.2-65.1l27.5-51.4h133.1 c5.5,43.1,9.2,78.9,11,105.6l-11,24.8h160.6l-23.9-34.9L1875.9,539.6L1875.9,539.6z M1780.4,795.7H1685l81.7-156.9L1780.4,795.7z  M1383.9,502c-49.5,0-91.8,13.8-129.4,41.3c-41.3,23.9-61.5,54.1-61.5,91.8c0,43.1,14.7,80.8,44,109.2l89,61.5 c32.1,23,47.7,43.1,47.7,61.5c0,17.4-8.3,33-23.9,45c-15.6,11.9-33.1,17.4-55.1,17.4c-32.1,0-87.2-22.9-163.4-65.1v85.3 c59.6,35.8,117.5,54.2,173.4,54.2c53.2,0,98.2-14.7,136.8-47.7c41.3-30.3,61.5-66.1,61.5-105.5c0-33.1-14.7-63.3-47.7-95.5 l-85.4-61.5c-28.4-22.9-44-43.1-44-58.7c0-35.8,21.1-54.1,64.2-54.1c29.4,0,72.5,16.5,130.3,51.4l17.5-89 C1489.5,515.8,1439,502,1383.9,502L1383.9,502z M1042.5,991.1c-1.8-19.3-5.5-36.7-7.4-55.1l116.6-376.3l27.5-34h-167.9 c1.8,8.3,3.7,19.3,5.5,27.5c0,8.3,0,18.4-1.8,27.5L898.5,953.5l-23.9,37.6L1042.5,991.1L1042.5,991.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.750c8aef2d3d061c64237257cd4cf07a.svg";
export { ForwardRef as ReactComponent };